<template>
  <router-link to="/">
    <!-- <img v-if="$store.getters.site" :src="$store.getters.site.logo" id="logo"> -->

    <div class="zyzlogo1">
      <img src="~@/assets/images/图层 941.png" class="logo">
    </div>

    <div class="zyzlogo2">
      <img src="~@/assets/images/图层 941.png" class="logo">
      <img :src="$store.getters.site.logo" class="logo2">
    </div>



  </router-link>
</template>

<script>
  export default {
    name: 'EnLogo',
    mounted() {
      // if (!this.$store.getters.site) {
      //   this.$store.dispatch('getCommonDataAction')
      // }
      // console.log(this.$store.getters.site.log)

    },
    data() {
      return {
        /** 商家基本信息 */
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
.zyzlogo1{
  .logo {
    width: 158px;
    height: 58px;
    margin-left: 15px;
    object-fit: contain;
  }
}
.zyzlogo2{
  display: none;
  .logo {
    width: 80px;
    height: 30px;
    position: relative;
    top: -52px;
  }
  .logo2 {
    width: 166px;
    height: 51px;
    margin-left: -35px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Logo.vue